import { useState } from "react";
import Radio from "../../components/inputs/radio";
import SearchInput from "../../components/inputs/searchInput";
import { FaCircle } from "react-icons/fa";
import { useFormik } from "formik";
import Button from "../../components/buttons/button";

const ManualRegistration = ({ t }) => {
  const [selectedStatus, setSelectedStatus] = useState("");
  const handleChange = (e) => {
    setSelectedStatus(e.target.id);
  };
  const formik = useFormik({
    initialValues: {},
  });
  return (
    <section>
      <div>
        <p className="mb-2 font-semibold">دورة كاراتيه</p>
        <p className="font-medium text-mainGray">20/06/2025</p>
      </div>
      <div className="my-4">
        <SearchInput formik={formik} name={"search"} placeholder={t("searchMember")} />
      </div>
      <div className="p-4 border rounded-lg border-primary bg-sideBar">
        <div>
          <p className="font-medium">هشام المدير هشام</p>
          <p className="font-medium text-mainGray">{t("membership")}: شبابي</p>
        </div>
        <div>
          <p className="my-4">{t("attendanceStatus")}</p>
          <div className="flex items-center gap-8">
            <Radio
              name="status"
              label={
                <span className="flex items-center justify-center gap-1">
                  {t("present")} <FaCircle className="text-[#11A849]" size={16} />{" "}
                </span>
              }
              id="1"
              checked={selectedStatus === "1"}
              onChange={handleChange}
            />
            <Radio
              name="status"
              label={
                <span className="flex items-center justify-center gap-1">
                  {t("absent")} <FaCircle className="text-[#FF0000]" size={16} />{" "}
                </span>
              }
              id="2"
              checked={selectedStatus === "2"}
              onChange={handleChange}
            />
            <Radio
              name="status"
              label={
                <span className="flex items-center justify-center gap-1">
                  {t("onlyRegistered")}{" "}
                  <FaCircle className="text-[#9CA3AF]" size={16} />{" "}
                </span>
              }
              id="3"
              checked={selectedStatus === "3"}
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div className="flex items-center justify-end gap-3 my-4">
        <Button className={"border border-white text-white text-sm"} type="button">
          {t("cancel")}
        </Button>
        <Button
          className={"bg-primary justify-center w-[150px] text-[#1F384C] text-sm"}
        >
          {t("addToActivity")}
        </Button>
      </div>
    </section>
  );
};

export default ManualRegistration;
